import * as React from 'react';
import { ToastContainer, ToastOptions, toast } from 'react-toastify';

export class NotificationContainer extends React.Component {
    render() {
        return <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable
            pauseOnHover
            theme="colored"
            closeButton
        />;
    }
}

export class NotificationHandler {
    public static showError(message: React.ReactNode, title: string = 'Error') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.error(content);
    }

    public static showInfo(message: string, title: string = 'Info') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.info(content);
    }

    public static showWarning(message: string, title: string = 'Warning') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.warning(content);
    }

    public static showSuccess(message: string, title: string = 'Success', optionsOverride?: ToastOptions) {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.success(content, optionsOverride);
    }
}